import { render } from "./DivCol.vue?vue&type=template&id=24962c78&ts=true"
import script from "./DivCol.vue?vue&type=script&lang=ts"
export * from "./DivCol.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__